import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from "react-router"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Block from 'components/common/Block'
import WineBlock from './WineBlock'
import ShoppingCartForm from './ShoppingCartForm'
import Loading from 'components/Loading'
import EmptyStorage from 'components/common/EmptyStorage'

import {
    getShippingCartList,
    getOrderAddress,
    getCoupons,
    updateShippingCart,
} from '../../actions/asyncOrders'

import {
    cleanShippingOrderData,
    saveShippingOrderData,
} from 'actions/orders'

const ShoppingCart = props => {
    const { t } = useTranslation()
    const [wineInCart, setWineInCart] = useState([])
    const [allWineInCart, setAllWineInCart] = useState([])
    const { shippingCart, memberInfo, isLoading, historyAddress, coupons,
        serviceFee, shippingFee, shippingOrderData,
        updateShippingCart,
    } = props

    // component did mount
    useEffect(() => {
        props.getShippingCartList(1, 24) // page, perPage // TODO: check pagination
        props.getOrderAddress()
        props.getCoupons('available', 1, 20) // status, page, perPage
    }, [])

    const onSubmit = (formData) => {
        const query = {
            ...formData,
            storageOrderItem: wineInCart,
            cellarId: memberInfo.storageCellarId[0],
        }
        query.shippingUrgency = parseInt(query.shippingUrgency)
        props.saveShippingOrderData(query)
        props.history.push('/member/shippingcart/comfirm')
    }

    const goBack = () => {
        props.history.push('/member/wines')
    }

    // get wine in cart
    useEffect(() => {
        if (props.getShippingCartSucc) {
            const orderItem = shippingCart.get('list').reduce((acc, curr) => {
                const orderItemIds = curr.get('storageOrderItems')
                    .filter(storageOrderItems => storageOrderItems.get('isInCart'))
                    .map(storageOrderItems => storageOrderItems.get('id'))
                return acc.concat(orderItemIds.toJS())
            }, [])
            setWineInCart(orderItem)
            setAllWineInCart(orderItem)
        }

        // if (props.createShippingOrderSucc) {
        //     props.history.push('/member/shippingcart/comfirm')
        // }
        // if(props.createShippingOrderFail) {
        //     window.alert('您尚有儲存費用未繳納，須先進行繳納後才能進行托運出窖唷！/ 本次托運車含箱入愛酒，請聯繫客服。')
        // }
    }, [props.getShippingCartSucc, props.createShippingOrderFail])

    const updateWineInCart = (event) => {
        const wineId = parseInt(event.target.value, 10)
        let newData = []
        if (event.target.checked) { // add to cart
            newData = wineInCart.concat([wineId])
        } else { // rm from cart
            newData = wineInCart.filter(item => item !== wineId)
        }
        setWineInCart(newData)
    }

    if (!shippingCart.get('list').size) {
        return (<EmptyStorage type="cart" onClick={goBack} />)
    }

    return (
        <Grid container alignItems="center" className="shopping-cart">
            <Loading isLoading={isLoading} />
            <Grid container>
                <Typography variant="h1">{t('shipping_info_confirm')}</Typography>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={8}>
                    <Block title={
                        <Grid container alignItems="center">
                            <i className="material-icons">arrow_back</i>
                            {t('back_to_wine_list')}
                        </Grid>
                    }
                        onClick={goBack}
                    >
                        {shippingCart.get('list').map((item, idx) => (
                            <WineBlock key={item.get('id')} data={item}
                                updateWineInCart={updateWineInCart}
                                wineInCart={wineInCart}
                                allWineInCart={allWineInCart}
                                updateShippingCart={updateShippingCart}
                            />
                        ))}
                    </Block>
                </Grid>
                <Grid item xs={4}>
                    <ShoppingCartForm
                        memberInfo={memberInfo}
                        couponlist={coupons.get('list')}
                        historyAddress={historyAddress}
                        amountWineInCart={wineInCart.length || 0}
                        onSubmit={onSubmit}
                        serviceFee={serviceFee}
                        shippingFee={shippingFee}
                        shippingOrderData={shippingOrderData}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

const mapStateToProps = state => ({
    shippingCart: state.orders.shippingCart,
    getShippingCartSucc: state.orders.getShippingCartSucc,
    // createShippingOrderSucc: state.orders.createShippingOrderSucc,
    // createShippingOrderFail: state.orders.createShippingOrderFail,
    isLoading: state.orders.isLoading,
    memberInfo: state.member.member,
    historyAddress: state.orders.historyAddress,
    coupons: state.orders.coupons,
    serviceFee: state.orders.serviceFee,
    shippingFee: state.orders.shippingFee,
    shippingOrderData: state.orders.shippingOrderData,
})

const mapDispatchToProps = {
    getShippingCartList,
    getOrderAddress,
    getCoupons,
    saveShippingOrderData,
    cleanShippingOrderData,
    updateShippingCart,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ShoppingCart))